<template>
  <div class="main">
    <div class="align-items">
      <div>
        <img class="logo-header" src="../../../assets/logo-indecx.png" />
      </div>
      <div class="content-text">
        <div v-if="lang === 'br'">
          <label class="text-research">Pesquisa de satisfação</label>
          <p>
            Sua opinião é muito importante para nós!<br />
            Agradecemos sua participação!
          </p>

          <img
            class="logo-indecx-desktop"
            src="../../../assets/logo-indecx.png"
          />
        </div>
        <div v-if="lang === 'us'">
          <label class="text-research">Satisfaction survey</label>
          <p>
            Your opinion is very important to us!<br />
            Thank you for your participation.
          </p>

          <img
            class="logo-indecx-desktop"
            src="../../../assets/logo-indecx.png"
          />
        </div>
        <div v-if="lang === 'es'">
          <label class="text-research">Encuesta de satisfacción</label>
          <p>
            ¡Su opinión es muy importante para nosotros!<br />
            Gracias por su participación.
          </p>

          <img
            class="logo-indecx-desktop"
            src="../../../assets/logo-indecx.png"
          />
        </div>
      </div>
      <div>
        <img
          style="max-width: 100%; heigth: auto"
          src="../../../assets/img-final-research.png"
        />
      </div>
      <div class="aling-center-indecx">
        <img
          style="max-width: 100%; heigth: 70px; width: 132px"
          src="../../../assets/logo-indecx.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
import img from '../../../assets/img-final-research.png';

export default {
  name: 'ThankYouPage',
  props: {
    lang: {
      type: String,
      required: false,
      default: 'br',
    },
  },

  data: () => ({
    img,
  }),
};
</script>

<style lang="scss" scoped>
.main {
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 110px;
  height: 100%;
}

.logo-header {
  max-width: 100%;
  height: 46px;
  width: auto;
}

.logo-indecx-desktop {
  display: none;
}

.content-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  margin-top: 108px;
  width: 350px;
}

.aling-center-indecx {
  justify-content: center;
  display: flex;
}

.align-items {
  display: flex;
  flex-direction: column;
  gap: 64px;
}

.text-research {
  font-size: 26px;
  font-weight: 700;
  line-height: 30px;
  color: #527bf2;
}

@media (min-width: 768px) {
  .main {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
  }

  .align-items {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    flex-direction: row;
  }

  .content-text {
    display: flex;
  }

  .aling-center-indecx {
    display: none;
  }

  .logo-header {
    display: none;
  }

  .logo-indecx-desktop {
    display: block;
    height: 46px;
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/final-pages/thank-you-page.vue